import type {ReactElement} from 'react';
import {useEffect} from 'react';
import {useIsSmallerThanBreakpointWidth} from '@Hooks/useIsSmallerThanBreakpoint';
import {ScreenBreakpoints} from '@Libraries/responsiveness-library';
import {openEmailMakerSaveErrorModal} from '@Modals/email-maker-save-error-modal/email-maker-save-error-modal';
import {EmailMakerSaveErrorPopup} from '../email-maker-save-error-popup/email-maker-save-error-popup';
import type {EmailMakerSaveErrorPopoverProps} from './email-maker-save-error-popover.types';
import {hasDisplayableSaveError} from './email-maker-save-error-popover.types';
import styles from './email-maker-save-error-popover.module.scss';

/** Self-switches like the conflict popover: an inline card on desktop, an opened modal on mobile/tablet. */
export function EmailMakerSaveErrorPopover({saveError, isOpen, onClose}: EmailMakerSaveErrorPopoverProps): ReactElement | null {
  const isMobileWidth = useIsSmallerThanBreakpointWidth(ScreenBreakpoints.MEDIUM);
  const shouldOpenMobileModal = isOpen && isMobileWidth && hasDisplayableSaveError(saveError);

  useEffect(() => {
    if (shouldOpenMobileModal && saveError !== null) {
      openEmailMakerSaveErrorModal({saveError});
      onClose();
    }
  }, [shouldOpenMobileModal, saveError, onClose]);

  if (!isOpen || isMobileWidth || !hasDisplayableSaveError(saveError)) {
    return null;
  }

  return (
    <div className={styles.popover}>
      <EmailMakerSaveErrorPopup saveError={saveError} onClose={onClose} />
    </div>
  );
}
